import { render, staticRenderFns } from "./EquipmentBRC.vue?vue&type=template&id=6c3be4fc"
import script from "./EquipmentBRC.vue?vue&type=script&lang=js"
export * from "./EquipmentBRC.vue?vue&type=script&lang=js"
import style0 from "../EquipmentBRC/EquipmentBRC.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports